module.exports = __webpack_public_path__ + "assets/img/lvjiachi_5013_3.e965f5e7.jpg";